import { jsx, jsxs } from "react/jsx-runtime";
import { TPAComponentsProvider, Text, TextTypography, TextButton, TextButtonPriority } from "@wix/wix-ui-tpa/cssVars";
import { useState, useEffect } from "react";
import styles from "./error-fallback.module.scss";
const TextWithChildren = Text;
const ErrorFallback = ({ errorMessage, errorId }) => {
  const isSSR = typeof window === "undefined";
  const [isReady, setIsReady] = useState(isSSR);
  useEffect(() => {
    setIsReady(true);
  }, []);
  if (!isReady) {
    return null;
  }
  return /* @__PURE__ */ jsx(TPAComponentsProvider, { value: {}, children: /* @__PURE__ */ jsxs("div", { "data-hook": "error-fallback-root", className: styles.container, children: [
    /* @__PURE__ */ jsx(
      TextWithChildren,
      {
        className: styles.title,
        typography: TextTypography.smallTitle,
        children: "Something went wrong..."
      }
    ),
    errorMessage ? /* @__PURE__ */ jsx(
      TextWithChildren,
      {
        "data-hook": "error-fallback-error-message",
        typography: TextTypography.runningText,
        children: errorMessage
      }
    ) : null,
    errorId ? /* @__PURE__ */ jsxs(
      TextWithChildren,
      {
        "data-hook": "error-fallback-error-id",
        typography: TextTypography.runningText,
        children: [
          "Error ID: ",
          errorId
        ]
      }
    ) : null,
    /* @__PURE__ */ jsx(
      TextButton,
      {
        className: styles.textButton,
        priority: TextButtonPriority.primary,
        onClick: () => window.location.reload(),
        children: "Refresh"
      }
    )
  ] }) });
};
export {
  ErrorFallback as default
};
//# sourceMappingURL=error-fallback.js.map
